<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <strong>{{ $t("fareUpload.title") }}</strong>
          </CCol>

          <p class="desc">{{ $t("fareUpload.desc") }}</p>
        </CRow>
      </CCardHeader>
      <ValidationObserver v-slot="{ handleSubmit,invalid }">
        <CCardBody class="user-manage-table pt-0px pb-0">
             <br>
          <div class="d-flex"  v-if="GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode">
          <h3>{{$t("contract.contractName")+' : '}}</h3>  <h3 class="text-transform-uppercase"> {{GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode}}</h3>
           </div>
            <div class="max-width-550 m-auto">
                <CRow>
                    <CAlert v-if="alertValue" show color="danger">
                        <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                            <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
                        </div>
                        <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                            <span>{{$t("cAlert.errorCode")+' : '}}</span>
                            <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
                        </div>
                        <div v-if="alertValue&&alertValue.constructor==String">
                            <p>{{alertValue}}</p>
                        </div>
                    </CAlert>
                </CRow>
                <br />

                <CRow>
                    <CCol>
                        <label>{{$t('fareUpload.from')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="flightFare.from"
                                    label="depcode"
                                    :allow-empty="false"
                                    :options="lsAirportCodes"
                                    :track-by="'depcode'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('fareUpload.depCityPl')"
                                    @input="isValidFare(flightFare)"
                            >
                                <template #noResult>
                                    <strong>{{$t('fareUpload.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                            <div v-if="!(errors && errors[0])&&depAlertValue" class="invalid-feedback icon">
                                <span>{{ depAlertValue }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>
                    <CCol>
                        <label>{{$t('fareUpload.to')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="flightFare.to"
                                    label="arrcode"
                                    :allow-empty="false"
                                    :options="lsAirportCodes"
                                    :track-by="'arrcode'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('fareUpload.arrCityPl')"
                                    @input="isValidFare(flightFare)"
                            >
                                <template #noResult>
                                    <strong>{{$t('fareUpload.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                            <!-- <div v-if="!(errors && errors[0])&&arrAlertValue" class="invalid-feedback icon">
                                <span>{{ arrAlertValue }}</span>
                            </div> -->
                        </ValidationProvider>
                    </CCol>

                </CRow>
                <br />
                <CRow>
                    <CCol>
                        <label>{{$t('fareUpload.type')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="flightFare.type"
                                    label="name"
                                    :allow-empty="false"
                                    :options="lsFareType"
                                    :track-by="'code'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('fareUpload.fareTypePl')"
                            >
                                <template #noResult>
                                    <strong>{{$t('fareUpload.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>
                    <CCol>
                        <cOrgCurrencyDp v-if="isOrgCurrencyDp && GET_ORG_CURRENCY_RES"
                                        v-model="flightFare.currency"
                                        :defaultCurrency="defaultCurrency"
                                        :ctrlCode="'id'"
                                        :isShowCode="true"
                                        :isMultiple="false"
                                        :isSearchable="true"
                                        :isAllowEmpty="false"
                                        rules="required"
                                        :label="$t('fareUpload.currency')"
                                        @input="getSelectedCurrency"
                        ></cOrgCurrencyDp>
                    </CCol>

                </CRow>
                <br />
                <CRow>
                    <CCol>
                        <!--              <label>{{$t('fareUpload.fare')}}</label>-->

                        <cTextInputComponent
                                :label="$t('fareUpload.fare')"
                                :isAmountField="true"
                                @onBlur="formatFareAmount(flightFare.fare)"
                                @onFocus="onRemoveCurrFormat(flightFare.fare)"
                                v-model="flightFare.fare"
                                :placeholder="$t('fareUpload.farePl')"
                                rules="required|onlynumber"
                        />
                    </CCol>
                    <CCol>
                        <label>{{$t('fareUpload.passengerType')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="flightFare.passengerType"
                                    label="name"
                                    :allow-empty="false"
                                    :options="lsPassengerType"
                                    :track-by="'code'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('fareUpload.passengerTypePl')"
                            >
                                <template #noResult>
                                    <strong>{{$t('fareUpload.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>

                </CRow>
                <br />
                <CRow>
                    <CCol>
                        <!--              <label>{{$t('fareUpload.class')}}</label>-->
                        <cTextInputComponent
                                v-model="flightFare.class"
                                :placeholder="$t('fareUpload.classPl')"
                                rules="required|no_spcl_char|Atmax:10"
                                label="Class"
                        />
                    </CCol>
                    <CCol>
                        <!--                  <label>{{$t('fareUpload.maxSeats')}}</label>-->
                        <cTextInputComponent
                                v-model="flightFare.maxSeats"
                                :placeholder="$t('fareUpload.maxSeatsPl')"
                                rules="required|onlyNumber"
                                label="Maximum Seats"
                                :maxLength="4"
                        />
                    </CCol>
                </CRow>
                <br />
                <CRow>
                    <CCol>
                        <!--              <label>{{$t('fareUpload.fareBasisCode')}}</label>-->
                        <cTextInputComponent
                                v-model="flightFare.fareBasisCode"
                                :placeholder="$t('fareUpload.fareBasisCodePl')"
                                rules="required|minimum:3|Atmax:10"
                                label="Fare Basis Code"
                        />
                    </CCol>
                    <CCol>
                        <label>{{$t('fareUpload.fareRule')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">

                            <multiselect
                                    v-model="flightFare.fareRule"
                                    label="farerule_code"
                                    :allow-empty="false"
                                    :options="lsFareRule"
                                    :track-by="'ruleid'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('fareUpload.fareRulePl')"

                            >
                                <!-- <template slot="singleLabel" slot-scope="{ option }">{{ option.farerule_code}}</template> -->

                                <template #noResult>
                                    <strong @click="navToAddFareRuleNew">{{$t('fareUpload.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <!-- <multiselect
                              v-model="flightFare.fareRule"
                              label="name"
                              :allow-empty="false"
                              :options="[]"
                              :track-by="'code'"
                              deselectLabel
                              deselectGroupLabel
                              selectLabel
                              selectedLabel
                              :placeholder="$t('fareUpload.fareRulePl')"
                            >
                              <template #noResult>
                                <strong>{{$t('fareUpload.listEmpty')}}</strong>
                              </template>
                            </multiselect> -->
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>
                </CRow>
                <br />
                <CRow>
                    <CCol>
                        <label>{{$t('fareUpload.cabinType')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="flightFare.cabinType"
                                    label="name"
                                    :allow-empty="false"
                                    :options="lsCabinType"
                                    :track-by="'code'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('fareUpload.cabinTypePl')"
                            >
                                <template #noResult>
                                    <strong>{{$t('fareUpload.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>
                </CRow>
                <br />
            </div>



          <!-- </CRow> -->
          <CCardFooter>
            <CRow class="d-flex justify-content-end">
    <div class="d-flex">
        <CButton
                @click="navToFareUploadAll"
                color="danger"
                class="action-c-btn mr-15px"
        >{{$t('fareUpload.cancelBtn')}}</CButton>
        <CButton
                col="12"
                color="success removewrap"
                class="action-c-btn"
                @click.prevent="handleSubmit(onShowCreateFareModal),invalid?isValidFare(flightFare):alertValue=null"
        >{{GET_SEL_FLIGHT_SCHEDULE?$t('fareUpload.updateBtn'):$t('fareUpload.createBtn')}}</CButton>
</div>


            </CRow>
          </CCardFooter>

          <!-- table filter hidded
          tableFilter-->
          <!-- <button class="mf-success-round-btn">Apply</button> -->
        </CCardBody>
      </ValidationObserver>
    </CCard>

    <cAlertModal
      v-if="isCreateFareModal"
      :buttonList="[{
              name:$t('fareUpload.noBtn'),func:onHideConfirmationModals,color:'danger'},
                {name:$t('fareUpload.yesBtn'),func:onCreateflightFare,color:'success'},]"
      :status="2"
      :show="isCreateFareModal"
      :desc="GET_SEL_FLIGHT_SCHEDULE?$t('fareUpload.updateFareConfirmation'):$t('fareUpload.createFareConfirmation')"
    ></cAlertModal>

    <cAlertModal
      v-if="isFareCreated"
      :buttonList="[{name:$t('fareUpload.okBtn'),func:onHideConfirmationModals,color:'success'}]"
      :status="1"
      :show="isFareCreated"
      :desc="GET_SEL_FLIGHT_SCHEDULE?$t('fareUpload.fareUpdatedSuccDesc'):$t('fareUpload.fareCreatedSuccDesc')"
    ></cAlertModal>

    <cAlertModal
      v-if="isFailedModal"
      :buttonList="[{name:$t('fareUpload.okBtn'),func:onHideConfirmationModals,color:'danger'}]"
      :status="0"
      :show="isFailedModal"
      :desc="alertValue"
    ></cAlertModal>
  </div>
</template>

<script>
import router, { navigate, updateDataEdited } from "../../../../router/index";

import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  ORDER,
  TRIP,
  PAX
} from "../../../../util/constants";
import Logger from "../../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../../../config/API_DATA";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneData,removeCurrFormat
} from "../../../../util/util";
import BaseConfiguration from "../../../../config/base.js";
import apiGetAirports from "../../../../services/apiGetAirports";
import Multiselect from "vue-multiselect";
import apiGetAllAirlines from "../../../../services/apiGetAllAirlines";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";

import { ValidationObserver, ValidationProvider, localize } from "vee-validate";
// import VueTimepicker from "vue2-timepicker";
import apiCreateFlightFare from "../../../../services/apiCreateFlightFare";
import cAlertModal from "../../../../components/form/cAlertModal";
import apiUpdateFlightFare from "../../../../services/apiUpdateFlightFare";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import cOrgCurrencyDp from "../../../../components/currency/cOrgCurrencyDp";
import apiGetFareRule from "../../../../services/apiGetFareRule";
import { i18n } from "../../../../plugins/i18n.js";
import apiGetFlightScheduleRoutes from "../../../../services/apiGetFlightScheduleRoutes";


export default {
  name: COMPONENT_NAME.FARE_UPLOAD_NEW,
  components: {
    Multiselect,
    cTextInputComponent,
    ValidationObserver,
    ValidationProvider,
    VueTimepicker,
    cAlertModal,
    cOrgCurrencyDp
  },

  data: () => {
    return {
      alertValue: null,
      lsAirlines: [],
      lsAirportCodes: [],
      flightFare: {
        from: null,
        to: null,
        type: null,
        currency: null,
        fare: null,
        passengerType: null,
        class: null,
        fareRule: null,
        fareBasisCode: null,
        cabinType:null,
        maxSeats:null
      },
      lsScheduleType: [
        {
          name: i18n.tc('fareUpload.weekly'),
          value: 1
        },
        {
          name: i18n.tc('fareUpload.monthly'),
          value: 2
        }
      ],
      lsFareType: [
        {
          name: i18n.tc('fareUpload.oneWay'),
          code: TRIP.OW
        },
        {
          name: i18n.tc('fareUpload.roundTrip'),
          code: TRIP.RT
        }
      ],
      lsPassengerType: [
        {
          name: i18n.tc('fareUpload.adult'),
          code: PAX.ADULT
        },
        {
          name: i18n.tc('fareUpload.child'),
          code: PAX.CHILDREN
        },
        {
          name: i18n.tc('fareUpload.infant'),
          code: PAX.INFANT
        }
      ],
      lsCabinType: [
       
       
      ],
      lsScheduleValues: [],
      isCreateFareModal: false,
      isFareCreated: false,
      isFailedModal: false,
      defaultCurrency:null,
      isOrgCurrencyDp:true,
      lsFareRule:[],
      depAlertValue:null,
     // arrAlertValue:null
    };
  },

  methods: {
 ...mapActions("sFlightSchedule", {

                SET_IS_NAV_FRM_FU: "SET_IS_NAV_FRM_FU"
            }),
    fareRulePickCustomeLabel(option) {
      return `${option.ruleCode}`;
    },


  getCabinTypes() {
    let retValue
      try {
        if(BaseConfiguration.isDebug) console.log("getCabinTypes");
         retValue= [{
          name: i18n.tc('fareUpload.economy'),
          code: this.CABIN_TYPE.Economy
        },
        {
          name: i18n.tc('fareUpload.business'),
          code: this.CABIN_TYPE.Business
        },];
  
      } catch (err) {
              let body = Logger.buildRequest(
                FILE_NAME.FARE_UPLOAD_NEW,
                "error in getCabinTypes",
                err.toString(),
                "getCabinTypes",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
        return retValue;
      }, 

    navToAddFareRuleNew() {
        try {
          if(BaseConfiguration.isDebug) console.log("navToAddFareRuleNew");
          this.SET_IS_NAV_FRM_FU(true);
          navigate(PATHNAME.FARE_RULE_NEW);

        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_UPLOAD_NEW,
                  "error in navToAddFareRuleNew",
                  err.toString(),
                  "navToAddFareRuleNew",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }

        },

             onRemoveCurrFormat(pCreditAmount) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");

                    this.flightFare.fare = removeCurrFormat(pCreditAmount);

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_UPLOAD_NEW,
                        "error in onRemoveCurrFormat",
                        err.toString(),
                        "onRemoveCurrFormat",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
 formatFareAmount(val) {
                if (BaseConfiguration.isDebug) console.log(" formatFareAmount");
                try {
                  if(val&&this.flightFare.currency){
  this.flightFare.fare = this.$options.filters.currencyFormat(val, this.flightFare.currency.currency_code.code);
                  }
                  
                    // this.creditNote.creditAmount = this.creditAmount;
                } catch (err) {
                    let body = Logger.buildRequest(
                         COMPONENT_NAME.FARE_UPLOAD_NEW,
                        "error in formatFareAmount",
                        err.toString(),
                        "formatFareAmount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
      getSelectedCurrency(pCurrency) {
          try {
            if(BaseConfiguration.isDebug) console.log("getSelectedCurrency");
           this.flightFare.currency=pCurrency;
           this.formatFareAmount(this.flightFare.fare);
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.FARE_UPLOAD_NEW,
                    "error in getSelectedCurrency",
                    err.toString(),
                    "getSelectedCurrency",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
          }, 
    onShowCreateFareModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("onShowCreateFareModal");
        if(this.isValidFare(this.flightFare)){
        this.isCreateFareModal = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in onShowCreateFareModal",
          err.toString(),
          "onShowCreateFareModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onHideConfirmationModals() {
      try {
        if (BaseConfiguration.isDebug) console.log("onHideConfirmationModals");

        this.isCreateFareModal = false;
        this.isFailedModal = false;

        if (this.isFareCreated) {
          navigate(PATHNAME.FARE_UPLOAD_ALL);
          this.isFareCreated = false;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in onHideConfirmationModals",
          err.toString(),
          "onHideConfirmationModals",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    navToFareUploadAll() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToFareUploadAll");
        navigate(PATHNAME.FARE_UPLOAD_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in navToFareUploadAll",
          err.toString(),
          "navToFareUploadAll",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // async getAirportCodes() {
    //   let airportList = [];
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getAirportCodes");
    //     let airportRequest = apiGetAirports.buildRequest();

    //     if (airportRequest) {
    //       let airportResponse = await apiGetAirports.getResponse(
    //         airportRequest
    //       );

    //       if (VALIDATE_SUCCESS_RES(airportResponse)) {
    //         this.alertValue = null;
    //         airportList = airportResponse.data.data;
    //       } else {
    //         let error = getErrorMessage(airportResponse);

    //         let isJwt = handleJWT(error);
    //         if (!isJwt) {
    //           this.alertValue = getErrorAlertValue(error);
    //         }
    //       }
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.FARE_UPLOAD_NEW,
    //       "error in getAirportCodes",
    //       err.toString(),
    //       "getAirportCodes",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return airportList;
    // },
     async getFlightScheduleRoutes() {
      let airportList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getFlightScheduleRoutes");
        let airportRequest = apiGetFlightScheduleRoutes.buildRequest(this.GET_SELECTED_CONTRACT?this.GET_SELECTED_CONTRACT.contractid:null);

        if (airportRequest) {
          let airportResponse = await apiGetFlightScheduleRoutes.getResponse(
            airportRequest
          );

          if (VALIDATE_SUCCESS_RES(airportResponse)) {
            this.alertValue = null;
            airportList = airportResponse.data.data.routes;
          } else {
            let error = getErrorMessage(airportResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getFlightScheduleRoutes",
          err.toString(),
          "getFlightScheduleRoutes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return airportList;
    },

    async getAllAirlines() {
      let airportList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAllAirlines");
        let pGetAllAirlineReq = {
          contractcode: "",
          description: "",
          airline_code: "",
          traveldate_from: "",
          traveldate_to: "",
          ticketingdate_from: "",
          ticketingdate_to: "",
          isfareonly_contract: "",
          providerid: null
        };
        let airportRequest = apiGetAllAirlines.buildRequest(pGetAllAirlineReq);

        if (airportRequest) {
          let airportResponse = await apiGetAllAirlines.getResponse(
            airportRequest
          );

          if (VALIDATE_SUCCESS_RES(airportResponse)) {
            this.alertValue = null;
            airportList = airportResponse.data.data;
          } else {
            let error = getErrorMessage(airportResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getAllAirlines",
          err.toString(),
          "getAllAirlines",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return airportList;
    },
    async onCreateflightFare() {
      try {
        if (BaseConfiguration.isDebug) console.log("onCreateflightFare");
      updateDataEdited(false);

        // if (getAllAirlineReq) {
        if (this.GET_SEL_FLIGHT_SCHEDULE) {
          let flightFareReq = this.updateFlightFareRequest(this.flightFare);
          if (flightFareReq) {
            let retFlightScheRes = await this.updateflightFare(flightFareReq);
            this.isCreateFareModal = false;
            if (retFlightScheRes) {
              this.isFareCreated = true;
            } else {
              this.isFailedModal = true;
            }
          } else {
            throw "invalid request";
          }
        } else {
          let flightFareReq = this.createFlightFareRequest(this.flightFare);
          if (flightFareReq) {
            let retFlightScheRes = await this.createflightFare(flightFareReq);
            this.isCreateFareModal = false;
            if (retFlightScheRes) {
              this.isFareCreated = true;
            } else {
              this.isFailedModal = true;
            }
          } else {
            throw "invalid request";
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in onCreateflightFare",
          err.toString(),
          "onCreateflightFare",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    createFlightFareRequest(pflightFare) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createFlightFareRequest");

        retValue = {
           contract: this.GET_SELECTED_CONTRACT?Number(this.GET_SELECTED_CONTRACT.contractid):null,
          depcode: pflightFare.from.depcode,
          arrcode: pflightFare.to.arrcode,
          currency:pflightFare.currency&&pflightFare.currency.currency_code
            ? pflightFare.currency.currency_code.code
            : null,
          fare_type: pflightFare.type ? pflightFare.type.code : null,
          cabin_type: pflightFare.cabinType?pflightFare.cabinType.code:null,
          pax_type: pflightFare.passengerType.code,
          basefare_amount: Number(pflightFare.fare),
          booking_class: pflightFare.class.toUpperCase(),
          // ruleCode: pflightFare.fareRule.ruleCode,
          airline_farebasis_code: pflightFare.fareBasisCode,
          rule:pflightFare.fareRule?Number(pflightFare.fareRule.ruleid):null,
           "max_seats": Number(pflightFare.maxSeats)
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in createFlightFareRequest",
          err.toString(),
          "createFlightFareRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    updateFlightFareRequest(pflightFare) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateFlightFareRequest");
        retValue = {
          fareid:this.GET_SEL_FLIGHT_SCHEDULE? Number(this.GET_SEL_FLIGHT_SCHEDULE.fareid):null,
          depcode: pflightFare.from.depcode,
          arrcode: pflightFare.to.arrcode,
          currency:pflightFare.currency&& pflightFare.currency.currency_code
            ? pflightFare.currency.currency_code.code
            : null,
          fare_type: pflightFare.type ? pflightFare.type.code : null,
          cabin_type: pflightFare.cabinType?pflightFare.cabinType.code:null,
          pax_type: pflightFare.passengerType.code,
          basefare_amount: Number(pflightFare.fare),
          booking_class: pflightFare.class.toUpperCase(),
          farerule_code: pflightFare.fareRule.farerule_code,
          airline_farebasis_code: pflightFare.fareBasisCode,
                     max_seats: Number(pflightFare.maxSeats),
          rule:pflightFare.fareRule?Number(pflightFare.fareRule.ruleid):null,

        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in updateFlightFareRequest",
          err.toString(),
          "updateFlightFareRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async createflightFare(pflightFareReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createflightFare");
        let scheduleRequest = apiCreateFlightFare.buildRequest(pflightFareReq);

        if (scheduleRequest) {
          let scheduleResponse = await apiCreateFlightFare.getResponse(
            scheduleRequest
          );

          if (VALIDATE_SUCCESS_RES(scheduleResponse)) {
            this.alertValue = null;
            retValue = scheduleResponse.data.data;
          } else {
            let error = getErrorMessage(scheduleResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in createflightFare",
          err.toString(),
          "createflightFare",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async updateflightFare(pflightFareReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateflightFare");
        let scheduleRequest = apiUpdateFlightFare.buildRequest(pflightFareReq);

        if (scheduleRequest) {
          let scheduleResponse = await apiUpdateFlightFare.getResponse(
            scheduleRequest
          );

          if (VALIDATE_SUCCESS_RES(scheduleResponse)) {
            this.alertValue = null;
            retValue = scheduleResponse.data.data;
          } else {
            let error = getErrorMessage(scheduleResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in updateflightFare",
          err.toString(),
          "updateflightFare",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getAirlineObj(pAirlineCode, pLsAirlines) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getAirlineObj");
        if (pAirlineCode && pLsAirlines) {
          for (let i = 0; i < pLsAirlines.length; i++) {
            if (pLsAirlines[i].airline_code == pAirlineCode) {
              retValue = pLsAirlines[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getAirlineObj",
          err.toString(),
          "getAirlineObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getToRouteObj(pAirlineCode, pLsAirportCodes) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getToRouteObj");
        if (pAirlineCode && pLsAirportCodes) {
          for (let i = 0; i < pLsAirportCodes.length; i++) {
            if (pLsAirportCodes[i].arrcode == pAirlineCode) {
              retValue = pLsAirportCodes[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getToRouteObj",
          err.toString(),
          "getToRouteObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getFromRouteObj(pAirlineCode, pLsAirportCodes) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getFromRouteObj");
        if (pAirlineCode && pLsAirportCodes) {
          for (let i = 0; i < pLsAirportCodes.length; i++) {
            if (pLsAirportCodes[i].depcode == pAirlineCode) {
              retValue = pLsAirportCodes[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getFromRouteObj",
          err.toString(),
          "getFromRouteObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getScheduleTypeObj(pFareType, pLsScheduleTypes) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getScheduleTypeObj");
        if (pFareType && pLsScheduleTypes) {
          for (let i = 0; i < pLsScheduleTypes.length; i++) {
            if (pLsScheduleTypes[i].value == pFareType) {
              retValue = pLsScheduleTypes[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getScheduleTypeObj",
          err.toString(),
          "getScheduleTypeObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    assignScheduleValuesAsActive(pflightFare) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getScheduleTypeObj");
        let retScheduleTypeObj = this.getScheduleTypeObj(
          pflightFare.scheduleType,
          this.lsScheduleType
        );

        if (pflightFare) {
          let lsScheduleValues = cloneData(this.lsScheduleValues);
          for (let i = 0; i < pflightFare.schedules.length; i++) {
            for (let j = 0; j < lsScheduleValues.length; j++) {
              if (pflightFare.schedules[i] == lsScheduleValues[j].value) {
                lsScheduleValues[j].isActive = true;
              }
            }
          }
          this.lsScheduleValues = lsScheduleValues;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getScheduleTypeObj",
          err.toString(),
          "getScheduleTypeObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    formatDepartureTime(pTime) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("formatDepartureTime");
        if (pTime) {
          retValue = {
            HH: pTime.substring(0, 2),
            mm: pTime.substring(3, 5)
          };
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in formatDepartureTime",
          err.toString(),
          "formatDepartureTime",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getCabinTypeObj(pCabinType) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getBookingClassObj");
       if(pCabinType && this.CABIN_TYPE){
           if(pCabinType==this.CABIN_TYPE.Economy){
               retValue=this.lsCabinType[0];
           }else if(  this.CABIN_TYPE &&pCabinType==this.CABIN_TYPE.Business){
               retValue=this.lsCabinType[1];
           }
       }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getBookingClassObj",
          err.toString(),
          "getBookingClassObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
     getCurrencyObj(pOrgCurrencies,pCurrency) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyObj");
        if (pOrgCurrencies&&pOrgCurrencies.data&&pOrgCurrencies.data.data && pCurrency) {
           for(let i=0;i<pOrgCurrencies.data.data.length;i++){
               if(pOrgCurrencies.data.data[i].currency_code==pCurrency){
                   retValue= pOrgCurrencies.data.data[i].currency_code;
                   break;

               }
           }
          
        }

      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getCurrencyObj",
          err.toString(),
          "getCurrencyObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

getFareTypeObj(pFareType) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getFareTypeObj");
       if(pFareType){
           if(pFareType==TRIP.OW){
               retValue=this.lsFareType[0];
           }else if(pFareType==TRIP.RT){
               retValue=this.lsFareType[1];
           }
       }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getFareTypeObj",
          err.toString(),
          "getFareTypeObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getPassengerTypeObj(pPassengerType) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getFareTypeObj");
       if(pPassengerType){
           if(pPassengerType==PAX.ADULT){
               retValue=this.lsPassengerType[0];
           }else if(pPassengerType==PAX.CHILDREN){
               retValue=this.lsPassengerType[1];
           }else if(pPassengerType==PAX.INFANT){
               retValue=this.lsPassengerType[2];
           }
       }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in getFareTypeObj",
          err.toString(),
          "getFareTypeObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getFareRuleByID(pFareRule,pLsFareRule) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getFareRuleByID");
         for(let i=0;i<pLsFareRule.length;i++){
           if(pFareRule.ruleId==pLsFareRule[i].ruleid){
             retValue=pLsFareRule[i];
             break;
           }
         }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_UPLOAD_NEW,
                  "error in getFareRuleByID",
                  err.toString(),
                  "getFareRuleByID",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    assignflightFare(pFare) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assignflightFare");
        let flightFare = cloneData(this.flightFare);
        if (pFare) {
           flightFare.fareBasisCode=pFare.airline_farebasis_code;
         flightFare.fare=this.$options.filters.currencyFormat(pFare.basefare_amount, pFare.currency);
         flightFare.class=pFare.booking_class;
         flightFare.cabinType=this.getCabinTypeObj(pFare.cabin_type);
        //  flightFare.currency=this.getCurrencyObj(this.GET_ORG_CURRENCY_RES,pFare.currency);

          flightFare.to = this.getToRouteObj(
            pFare.arrcode,
            this.lsAirportCodes
          );
          
          flightFare.from = this.getFromRouteObj(
            pFare.depcode,
            this.lsAirportCodes
          );
          flightFare.type = this.getFareTypeObj(pFare.fare_type);
          flightFare.passengerType=this.getPassengerTypeObj(pFare.pax_type)
 flightFare.fareBasisCode=pFare.airline_farebasis_code;
 flightFare.fareRule= this.getFareRuleByID(pFare,this.lsFareRule);
            flightFare.maxSeats= pFare.max_seats;

    
         
          
        }
        retValue = flightFare;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in assignflightFare",
          err.toString(),
          "assignflightFare",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
     async getFareRules() {
      if (BaseConfiguration.isDebug) console.log("getFareRules");
      let returnValue=[];
      try {
        let contractId = this.GET_SELECTED_CONTRACT
          ? this.GET_SELECTED_CONTRACT.contractid
          : null;
        let fareRuleReq = apiGetFareRule.buildRequest(contractId);

        if (fareRuleReq != null) {
          let fareRuleRes = await apiGetFareRule.getResponse(fareRuleReq);
          if (VALIDATE_SUCCESS_RES(fareRuleRes)) {
            returnValue = fareRuleRes.data.data.FlightFareList;
            this.permission = fareRuleRes.data.data.permission;
          } else {
            let error = getErrorMessage(fareRuleRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              // this.showAlert(getErrorAlertValue(error));
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_NEW,
          "error in  getFareRules",
          err.toString(),
          "getFareRules",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },
     isValidFare(pFlightFare) {
            try {
              if(BaseConfiguration.isDebug) console.log("isValidFare");
              this.depAlertValue = null;
             // this.arrAlertValue = null;
              if(pFlightFare){
                if(pFlightFare.from && pFlightFare.to && pFlightFare.from.depcode==pFlightFare.to.arrcode){
              this.depAlertValue=this.$t('fareUpload.depArrViaNotEqual');
              return false;
                }
                else{
                  return true;
                }
              }else{
                return false;
              }
            } catch (err) {
                    let body = Logger.buildRequest(
                       COMPONENT_NAME.FARE_UPLOAD_NEW,
                      "error in isValidFare",
                      err.toString(),
                      "isValidFare",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              return retValue;
            },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

         if(this.CABIN_TYPE)
         {
           this.lsCabinType =this.getCabinTypes()
         }



      if (this.GET_SEL_FLIGHT_SCHEDULE) {
        this.defaultCurrency=this.getCurrencyObj(this.GET_ORG_CURRENCY_RES,this.GET_SEL_FLIGHT_SCHEDULE.currency);
      }
      // this.lsAirportCodes = await this.getAirportCodes();
       this.lsAirportCodes = await this.getFlightScheduleRoutes();
      this.lsAirlines = await this.getAllAirlines();
      this.lsFareRule = await this.getFareRules();

      if (this.GET_SEL_FLIGHT_SCHEDULE) {
        // this.defaultCurrency=this.getCurrencyObj(this.GET_ORG_CURRENCY_RES,this.GET_SEL_FLIGHT_SCHEDULE.currency);
        let retflightFare = this.assignflightFare(
          this.GET_SEL_FLIGHT_SCHEDULE
        );
        if(retflightFare){
            
            this.isOrgCurrencyDp=false;
            let that = this;
                        setTimeout(function () {
                            that.isOrgCurrencyDp = true;
                        });
            this.flightFare=retflightFare;
            
        }
      }
      updateDataEdited(true);
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.FARE_UPLOAD_NEW,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
    ...mapGetters("sFlightSchedule", {
      GET_SEL_FLIGHT_SCHEDULE: "GET_SEL_FLIGHT_SCHEDULE",

    }),
    ...mapGetters("sContract", {
      GET_SELECTED_CONTRACT: "GET_SELECTED_CONTRACT",
      CABIN_TYPE:'GET_CABIN_TYPE'
    }),
     ...mapGetters("sCurrencyLs", {
     GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES"

    })
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.FARE_UPLOAD_NEW);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>
